module.exports = __webpack_public_path__ + "static/media/loading.4761f330.svg";